import type { DocumentStatus } from "../types.js";

export function canRemoveAttachedDoc(status: DocumentStatus): boolean {
  return status === "completed" || status === "failed";
}

export function attachedDocStatusLabel(status: DocumentStatus): string | null {
  switch (status) {
    case "pending":
      return "Pending";
    case "processing":
      return "Processing";
    case "failed":
      return "Failed";
    default:
      return null;
  }
}

export function isAttachedDocProcessing(status: DocumentStatus): boolean {
  return status === "pending" || status === "processing";
}
